import React from 'react';
import { BALANCE_METHOD_TO_IMAGE, IBalancingMethod } from '../Utils';
import ButtonDesigned from '../../../../components/UI-Elements/Buttons/ButtonDesigned';

interface BalancingMethodMetricCardProps {
  data: IBalancingMethod;
  image: string;
  isSelected?: boolean;
  onClick?: () => void;
}
export const BalancingMethodMetricCard: React.FC<BalancingMethodMetricCardProps> = ({
  data,
  image,
  isSelected = false,
  onClick = () => {},
}) => {
  const { infoTexts, title } = data;

  return (
    <div
      onClick={() => onClick()}
      className={`flex flex-1 overflow-auto shadow-md rounded-md p-3 gap-2 border-${
        isSelected ? 'red-200 border-r-2 border-y-2 border-l-8 -ml-[0.375rem]' : 'gray-50 border'
      } box-border`}
    >
      <img src={image} title="Star" className=" min-h-[1.5rem] min-w-[1.5rem]" />
      {title && <h5 className=" my-auto w-[12rem] overflow-auto whitespace-nowrap">{title}</h5>}
      <div className="flex flex-1  justify-around overflow-x-auto space-x-[0.5rem]">
        {infoTexts.map((item, index) => (
          <div className="flex flex-col" key={index}>
            <p className="whitespace-nowrap text-sm  text-gray-150">{item.title}</p>
            <p className="whitespace-nowrap">{item.data}</p>
          </div>
        ))}
        <div className="flex flex-col justify-center">
          <ButtonDesigned style="outline" onButtonClick={onClick} disableButton={isSelected}>
            Select
          </ButtonDesigned>
        </div>
      </div>
    </div>
  );
};
interface BalancingMethodMetricCardMapProps {
  balancingMethodsData: IBalancingMethod[];
}
export const BalancingMethodMetricCardMap: React.FC<BalancingMethodMetricCardMapProps> = ({ balancingMethodsData }) => {
  return (
    <>
      {balancingMethodsData
        .sort((b, a) => Math.abs(b.exposure) - Math.abs(a.exposure))
        .map((item, index) => (
          <BalancingMethodMetricCard
            isSelected={item.isSelected}
            onClick={() => item.onClick && item.onClick(item.type)}
            key={index}
            data={item}
            image={BALANCE_METHOD_TO_IMAGE[item.type].roundImage}
          />
        ))}
    </>
  );
};
